// The newest `modified` among `rows`, or `since` when none is newer.
//
// The status poll asks for the units modified since a time the server wrote,
// never the device clock: a tablet whose clock ran ahead used to miss every
// change saved in that gap, until the page was reloaded. The string is kept as
// the server wrote it (microseconds and offset), so nothing is rounded away.
export function newestModified(rows, since) {
    let newest = since
    let newest_ms = since ? Date.parse(since) : -Infinity
    for (const row of rows || []) {
        const ms = Date.parse(row?.modified)
        if (ms > newest_ms) {
            newest_ms = ms
            newest = row.modified
        }
    }
    return newest
}
